import React from "react";
import { Link } from "react-router-dom";

const footerLinks = [
  { label: "이용약관", to: "/pages/member-terms" },
  { label: "개인정보 처리방침", to: "/pages/member-policy" },
  { label: "회사소개", to: "/intro/aboutus" }
];

const FooterLink = ({ label, to }) => {
  if (to) {
    return (
      <Link
        to={to}
        target="_blank"
        rel="noreferrer"
        className="text-secondary text-decoration-none fw-medium"
        style={{ fontSize: "13px" }}
      >
        {label}
      </Link>
    );
  }

  return (
    <span
      className="text-secondary opacity-75 fw-medium"
      aria-disabled="true"
      style={{ fontSize: "13px" }}
    >
      {label}
    </span>
  );
};

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="main-footer site-footer border-top pt-4 pb-4 px-3 px-lg-4 text-secondary fs-sm">
      <div className="mx-auto text-center" style={{ maxWidth: "920px" }}>
        <div className="d-flex flex-wrap justify-content-center gap-2 gap-sm-3 mb-3">
          {footerLinks.map((link) => (
            <FooterLink key={link.label} {...link} />
          ))}
        </div>

        <p className="mx-auto mb-3 text-secondary" style={{ maxWidth: "700px", fontSize: "12px", lineHeight: 1.7 }}>
          구루위스퍼가 제공하는 모든 정보는 투자 참고용으로만 제공되며, 투자 결정의 유일한 근거로 사용되어서는 안됩니다.
          모든 투자에는 원금 손실 위험이 있으므로 본인 판단에 따라 투자하시기 바랍니다.
        </p>

        <div className="d-flex flex-wrap justify-content-center align-items-center gap-1 gap-sm-2 text-secondary" style={{ fontSize: "12px" }}>
          <span>© {year} GuruWhisper. All rights reserved.</span>
          <span className="opacity-50">|</span>
          <span>Powered by Woojung R&D, FMP</span>
          <span className="opacity-50">|</span>
          <a href="mailto:junsung.lim@guruwhisper.com" className="text-decoration-none">
            junsung.lim@guruwhisper.com
          </a>
        </div>
      </div>
    </footer>
  );
}
